export class NotificationSettingsModel {
    requistionApproved: boolean =true;
    requistionRejected: boolean =true;
    requistionInvoiced: boolean =true;
    requistionAnnotated: boolean =true;
    requistionCompleted: boolean =true;
    requistionFlagged: boolean =true;
    requistionMessage: boolean =true;
    clientRegistered: boolean =true;
}
